<div [ngClass]="ngClass">

  <ion-card class="card-padrao" (click)="touchOpenProduct(product.sku)">

    <ion-img class="imagem_produto" src="{{product.imageUrl}}" alt="{{product.name}}"></ion-img>

    <div class="dados_produto">

      <ion-label class="nome-produto">{{product.name}}</ion-label>

      <ion-row>

        <ion-col>
          <ion-button expand="block" class="btn-resgatar" color="dark" *ngIf="!product.preco">
            CARREGANDO...
          </ion-button>
          <ion-button expand="block" class="btn-resgatar" color="dark" *ngIf="product.preco">
            {{product.disponivel === false ? 'INDISPONÍVEL' : (product.precoProduto | precoVenda) + ' PONTOS'}}
          </ion-button>
        </ion-col>

        <ion-col>
          <ion-button expand="block" class="btn-resgatar">
            RESGATAR
          </ion-button>
        </ion-col>

      </ion-row>

    </div>
  </ion-card>
</div>
